import {BaseStore, globalStore} from "../../stem-core/state/Store";  // For order
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";
import {TopUpStatus} from "./TopUpPaymentStore";
import {MoneyObject} from "../../stem-core/localization/Money";
import {MerchantConversion} from "./merchant/MerchantConversionStore";
import {StemDate} from "../../stem-core/time/Date";
import {Merchant} from "./MerchantStore";
import {MerchantUser} from "./merchant/MerchantUserStore";
import {Payment} from "./PaymentStore";

@globalStore
export class Purchase extends BaseStore("Purchase", {dependencies: ["MerchantConversion"]}, MoneyObject) {
    @field(Date) createdAt: StemDate;
    @field(Date) finalizedAt: StemDate;
    @field(TopUpStatus) status: TopUpStatus;
    @field("Merchant") merchant: Merchant;
    @field(Number) userId: number;
    @field("MerchantUser") merchantUser: MerchantUser;
    @field("MerchantConversion") conversion: MerchantConversion;
    @field("Payment") payment: Payment;
    declare title: string;

    getTitle(): string {
        return this.title || `Order ${this.id}`;
    }

    isRefundable(): boolean {
        return this.payment?.isAutomatic;
    }
}

export async function apiUserPurchaseProduct(request: any): Promise<Purchase> {
    const response = await apiClient.post("/payments/purchase_product", request);
    return Purchase.loadObject(response);
}

export async function apiUserRequestPurchaseRefund(request: any): Promise<any> {
    return apiClient.post("/payments/request_refund", request);
}
